import React, { useState } from "react";
import styles from "./PreviewYesNo.module.scss";
import { ReactComponent as MoreInfoIcon } from "assets/svg/InformationIcon.svg";
import { ReactComponent as CrossIcon } from "assets/svg/x.svg";
import { useDispatch } from "react-redux";
import { setSelectedOptionsForFormula } from "redux/slices/scoringSlice";
import { previewFormFieldsMapping, showOptions, showOptionsDependency } from "utils/utils";

const PreviewYesNo = (props) => {
  const [showIcon, setShowIcon] = useState(
    props?.data?.showInstructions || false
  );
  const [selectedButton, setSelectedButton] = useState(""); // State to track selected button
  const dispatch = useDispatch();
  const handleOptionChange = (option) => {
    setSelectedButton((prev) => {
      const newValue = prev === option ? "" : option; // Toggle value

      // Always keep the ID, but update the value (set to empty string if deselected)
      dispatch(setSelectedOptionsForFormula({
        id: props.id || props?._id,
        value: newValue, // If same option is clicked again, it becomes ""
      }));

      return newValue; // Update local state
    });
  };

  // useEffect(() => {
  //   dispatch(
  //     setSelectedOptionsForFormula({ id: props.id, value: "Unanswered" })
  //   );
  // }, []);
  let strings = showOptionsDependency(props?.evaluation, props?.whenEvaluationEquals)
  let temp = strings?.split(",")
  return (
    <>
      <div className={styles.mainContainer}>
        <div className={styles.mainContent}>
          <div className={styles.heading}>
            <span>
              {props?.data?.required && <span style={{ color: "red" }}>*</span>}
              {props?.data?.value || props?.name || props?.label}
            </span>
            {props?.instructions || props?.data?.media?.length ? (
              <div>
                {showIcon ? (
                  <CrossIcon onClick={() => setShowIcon((prev) => !prev)} />
                ) : (
                  <MoreInfoIcon onClick={() => setShowIcon((prev) => !prev)} />
                )}
              </div>
            ) : null}
          </div>

          <div className={styles.buttons}>
            {props?.data?.options ?
              props?.data?.options.map((option) => {
                const isActive = selectedButton === option;
                const buttonStyle = {
                  Yes: isActive ? props?.evaluation?.passOn?.split(",")?.includes(selectedButton?.toLowerCase()) ? styles.activeYesButton : props?.evaluation?.neutralOn?.split(",")?.includes(selectedButton?.toLowerCase()) ? styles.activeNaButton : styles.activeNoButton : styles.yesButton,
                  No: isActive ? props?.evaluation?.passOn?.split(",")?.includes(selectedButton?.toLowerCase()) ? styles.activeYesButton : props?.evaluation?.neutralOn?.split(",")?.includes(selectedButton?.toLowerCase()) ? styles.activeNaButton : styles.activeNoButton : styles.noButton,
                  "N/A": isActive ? styles.activeNaButton : styles.naButton,
                }[option];

                return (
                  <button
                    key={option}
                    className={buttonStyle}
                    onClick={() => handleOptionChange(option)}
                  >
                    <span>{option}</span>
                  </button>
                );
              }
              ) : props?.options.map((option) => {
                const isActive = selectedButton === option;
                const buttonStyle = {
                  Yes: isActive ? props?.evaluation?.passOn?.split(",")?.includes(selectedButton?.toLowerCase()) ? styles.activeYesButton : props?.evaluation?.neutralOn?.split(",")?.includes(selectedButton?.toLowerCase()) ? styles.activeNaButton : styles.activeNoButton : styles.yesButton,
                  No: isActive ? props?.evaluation?.passOn?.split(",")?.includes(selectedButton?.toLowerCase()) ? styles.activeYesButton : props?.evaluation?.neutralOn?.split(",")?.includes(selectedButton?.toLowerCase()) ? styles.activeNaButton : styles.activeNoButton : styles.noButton,
                  "N/A": isActive ? styles.activeNaButton : styles.naButton,
                }[option];

                return (
                  <button
                    key={option}
                    className={buttonStyle}
                    onClick={() => handleOptionChange(option)}
                  >
                    <span>{option}</span>
                  </button>
                );
              }
              )}
          </div>
        </div>
        {showIcon && (
          <div className={styles.subContent}>
            {props?.instructions && (
              <div className={styles.instructionText}>
                {props?.instructions}
              </div>
            )}
            {props?.data?.media?.length ? (
              <>
                {props?.data?.media.map((image) => (
                  <img
                    key={image.path}
                    className={styles.imageStyle}
                    src={image.path}
                    alt="Preview"
                  />
                ))}
              </>
            ) : null}
          </div>
        )}
        {
          temp?.includes(selectedButton?.toLowerCase()) &&
          props?.dependentField?.map((ele) => {
            return props?.renderContent(ele)
          })
        }
      </div>
    </>
  );
};

export default PreviewYesNo;
